<template lang="html">
	<section class="documents-layout ctn-patrimonial-landscape">
		<article>
			<div class="title">
				Documents archivés
			</div>
			<div class="view-nav-template white-box row">
				<div class="menu column">
					<ul class="ctn-menu column">
						<li class="item-main" v-for="(item, key) in menu" v-bind:key="key" :class="{active: isActiveFirst(key)}">
							<div class="label" v-html="item.label" @click="setActiveFirst(key)"></div>
							<ul class="ctn-second" v-if="item.children && isActiveFirst(key)">
								<li class="item-second" v-html="child.label" v-for="(child, keyt) in item.children" v-bind:key="keyt" :class="{active: isActiveSecond(keyt)}" @click="setActiveSecond(keyt)"></li>
							</ul>
						</li>
					</ul>
				</div>
				<div class="view column">
					<div class="title row">
						<div class="inner-title" v-html="menu[activeFirstLevel].label"></div>
						<div class="btn btn-red" @click="showAddDocument=true">Ajouter un document</div>
					</div>
					<div class="ctn-component">
						<component v-if="drawComponent" :is="currentComponent" ref="currentComp"/>
					</div>
				</div>
			</div>
		</article>
		<base-modal :content="modalAddDocument" :show="showAddDocument" @close="resolveCloseAddDocument" />
	</section>
</template>

<script>
import ModalAddDocument from '@/components/Modal/AddDocument'
import Operations from '@/components/Documents/Operations'
import ModelsAndTemplates from '@/components/Documents/ModelsAndTemplates'
import PrivateDocs from '@/components/Documents/PrivateDocs'
import SharedDocs from '@/components/Documents/SharedDocs'
import ClientsJustificatory from '@/components/Documents/ClientsJustificatory'
import Patrimonial from '@/components/Documents/Patrimonial'
import Lcbft from '@/components/Documents/Lcbft'
import Subscription from '@/components/Documents/Subscription'
import CompanySignature from '@/components/Documents/CompanySignature'

export default {
	mounted () {
		this.$store.dispatch('fetchDocuments')
	},
	data () {
		return {
			drawComponent: true,
			modalAddDocument: ModalAddDocument,
			showAddDocument: false,
			menu: [
				{ label: '<span class="icon-doc-cr-mission"></span> Opérations', component: Operations },
				{ label: '<span class="icon-doc-others"></span> Justificatifs', component: ClientsJustificatory },
				{ label: '<span class="icon-doc-paysage"></span> Paysages patrimoniaux', component: Patrimonial },
				{ label: '<span class="icon-doc-subscription"></span> Abonnements', component: Subscription },
				{ label: '<span class="icon-doc-template"></span> Modèles de documents', component: ModelsAndTemplates },
				{ label: '<span class="icon-doc-template"></span> LCB-FT', component: Lcbft },
				{ label: '<span class="icon-doc-subscription"></span> Signature informations société', component: CompanySignature },
				{
					label: '<span class="icon-doc-private"></span> Autres Documents',
					children: [
						{ label: 'Partagés avec le client', component: SharedDocs },
						{ label: 'Privés', component: PrivateDocs }
					]
				}
			],
			activeFirstLevel: 0,
			activeSecondLevel: 0
		}
	},
	methods: {
		resolveCloseAddDocument () {
			this.showAddDocument = false
			this.$refs.currentComp.fetchDocs()
		},
		isActiveFirst (key) {
			return (this.activeFirstLevel === key)
		},
		setActiveFirst (key) {
			this.activeFirstLevel = key
		},
		isActiveSecond (key) {
			return (this.activeSecondLevel === key)
		},
		setActiveSecond (key) {
			this.activeSecondLevel = key
		}
	},
	computed: {
		currentComponent () {
			if (this.menu[this.activeFirstLevel].children) {
				if (this.activeSecondLevel !== -1) {
					return this.menu[this.activeFirstLevel].children[this.activeSecondLevel].component
				} else {
					return this.menu[this.activeFirstLevel].component
				}
			} else {
				return this.menu[this.activeFirstLevel].component
			}
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Documents.vue?5e546eb3